import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const subscriptions = {
    layout: {
        indexTitle: 'Recurring',
    },
    hero: {
        expenses: 'Expenses',
        income: 'Income',
        perYear: '{{amount}} per year',
        none: 'None yet',
        resultLeft: 'Left over per month',
        resultShort: 'Short per month',
    },
    item: {
        badgeHidden: 'Hidden',
        badgePaused: 'Paused',
        badgeIgnored: 'Ignored',
    },
    group: {
        category: 'Category',
        source: 'Source',
        all: 'Date',
    },
    sections: {
        activeRecurring: 'Active recurring',
        paused: 'Paused',
        hidden: 'Hidden',
        noSource: 'No source',
        noCategory: 'No category',
        itemCount_one: '{{count}} item',
        itemCount_other: '{{count}} items',
        perMonth: '{{amount}}/mo',
    },
    action: {
        subNextNear: '{{weekday}}, the {{day}}',
        subNextFar: 'on {{date}}',
        enableBillAlert: 'Enable charge alert',
        enableBillAlertDesc: 'Alerts you 1 day before so you can cancel in time',
        stopAlert: 'Stop alerts',
        stopAlertDesc: 'Turns off the charge alert',
        alertOneDayBefore: 'Alert 1 day before',
        alertOneDayBeforeDesc: 'Reminder 1 day before the charge',
        unhide: 'Unhide',
        unhideDesc: 'Show it in the list again',
        edit: 'Edit',
        editDesc: 'Amount, frequency, category',
        resume: 'Resume',
        resumeDesc: 'Resume generating occurrences',
        pause: 'Pause',
        pauseDesc: 'Stop generating new occurrences',
        hide: 'Hide',
        hideDesc: 'Remove from the list, keeps counting',
    },
    calendar: {
        showA11y: 'Show calendar',
        hideA11y: 'Back to the list',
        weekdaySun: 'S',
        weekdayMon: 'M',
        weekdayTue: 'T',
        weekdayWed: 'W',
        weekdayThu: 'T',
        weekdayFri: 'F',
        weekdaySat: 'S',
        chargesCount_one: '{{count}} charge · {{total}}',
        chargesCount_other: '{{count}} charges · {{total}}',
        incomeCount_one: '{{count}} entry · {{total}}',
        incomeCount_other: '{{count}} entries · {{total}}',
        dayAccessibility: 'Day {{day}}, {{amount}} in charges',
        dayIncomeAccessibility: 'Day {{day}}, {{amount}} in income',
        chargesOfMonth: 'Charges this month',
        incomeOfMonth: 'Income this month',
        detailClose: 'Close',
        detailCharges: 'Charges',
        detailDayTotal: 'Day total',
        detailNoCharges: 'No charges',
        detailNoIncome: 'No income',
        emptyTitle: 'No charges in this period',
        emptyIncomeTitle: 'No income in this period',
        emptySubtitle: 'Switch the month or select another day to view your recurring items.',
    },
    filter: {
        title: 'Filter',
        clear: 'Clear',
        statusLabel: 'Status',
        statusActive: 'Active',
        statusPaused: 'Paused',
        statusHidden: 'Hidden',
        applyButton_one: 'View {{count}} recurring item',
        applyButton_other: 'View {{count}} recurring items',
    },
    newType: {
        title: 'New recurring item',
        expense: 'Expense',
        expenseDesc: 'Subscription, monthly fee, recurring bill',
        income: 'Income',
        incomeDesc: 'Salary, rent received, drawings',
    },
    list: {
        emptyTitle: 'No recurring items yet',
        emptySubtitle: 'Add a recurring expense or income (subscription, monthly fee, salary) and track the monthly and yearly total here.',
        emptyAction: 'Create recurring item',
        emptyExpenseTitle: 'No recurring expense',
        emptyExpenseSubtitle: 'Subscription, tuition, any bill that repeats — add it and see the monthly and yearly total.',
        emptyExpenseAction: 'Add recurring expense',
        emptyIncomeTitle: 'No recurring income',
        emptyIncomeSubtitle: 'Salary, rent received, owner pay — add what comes in every month and see what is left.',
        emptyIncomeAction: 'Add recurring income',
    },
    hideDialog: {
        title: 'Hide recurring item',
        message: 'Hide this recurring item from the list? It stays active and keeps counting in projections.',
        confirm: 'Hide',
    },
} satisfies DeepPartialStrings<TranslationSchema['subscriptions']>;
